module.exports = __webpack_public_path__ + "static/media/divide.38cec213.svg";